<template>
	<div
		v-if="items && items.length"
		class="ao-carousel"
	>
		<ao-icon-btn
			size="small"
			class="ao-carousel-full-size-btn"
			color="textBody"
			iconName="sizeMx"
			@click="fullscreen = true"
		/>
		<Carousel
			id="gallery"
			v-model="currentSlide"
			:items-to-show="1"
			:wrap-around="false"
			class="ao-carousel-main"
			@init="resizeParent"
		>
			<Slide
				v-for="slide in items"
				:key="slide"
			>
				<div class="ao-carousel-main-item">
					<img
						class="ao-carousel-main-item-image"
						:src="slide.photo"
						alt=""
					>
				</div>
			</Slide>
		</Carousel>

		<Carousel
			v-if="items && items.length > 1"
			id="thumbnails"
			ref="carousel"
			v-model="currentSlide"
			:items-to-show="4"
			:wrap-around="toWrapAround"
		>
			<Slide
				v-for="(slide, index) in items"
				:key="slide"
				class="ao-carousel-preview"
			>
				<div
					class="ao-carousel-item"
					style="width: 100%"
					@click="slideTo(index)"
				>
					<img
						class="ao-carousel-item-image"
						style="width: 100%"
						:src="slide.photo"
						alt=""
					>
				</div>
			</Slide>
		</Carousel>
		<div
			v-if="items && items.length > 3"
			class="d-flex justify-center align-center"
		>
			<span class="collapse-icon-background">
				<ao-icon
					iconName="groupOpen"
					size="small"
					class="ao-carousel-prev-item-icon text-textSecondary700"
					@click="prev"
				/></span>
			<span class="mx-2">{{ currentSlide + 1 }} из {{ items.length }}</span>
			<span class="collapse-icon-background">
				<ao-icon
					iconName="groupOpen"
					size="small"
					class="ao-carousel-next-item-icon text-textSecondary700"
					@click="next"
				/></span>
		</div>
		<v-dialog
			v-model="fullscreen"
			location="center"
		>
			<v-card
				color="textBody"
				class="ao-carousel-full-screen d-flex justify-center align-center"
			>
				<ao-icon-btn
					size="small"
					class="ao-carousel-full-size-btn"
					color="textBody"
					iconName="closeSmall"
					@click="fullscreen = false"
				/>
				<img
					:src="items[currentSlide] ? items[currentSlide].photo: items[0].photo"
					alt=""
				> 
			</v-card>
		</v-dialog>
	</div>
	<div v-else
		class="ao-text-800 ao-p2-medium ml-2">{{$t('No data')}}</div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
export default {
	name: 'AoCarousel',

	components: {
		Carousel,
		Slide,
		Pagination,
		Navigation,
	},

	props: {
		items: {
			type: Array,
			default: () => [],
		},
	},

	emits: {},

	data: () => ({
		currentSlide: 1,
		fullscreen: false,
	}),

	computed: {
		toWrapAround() {
			return this.items.length > 3
		},
	},

	created() {},

	methods: {
		resizeParent() {
			setTimeout(() => {
				this.$parent.callMaxHeight()
			}, 100)
		},
		slideTo(val) {
			this.currentSlide = val
		},
		next() {
			this.$refs.carousel.next()
		},
		prev() {
			this.$refs.carousel.prev()
		},
	},
}
</script>

<style lang="scss">
.ao-carousel {
	width: 100%;
	position: relative;
	.ao-carousel-main-item {
		width: 100%;
		height: 100%;
	}
	.ao-carousel-main-item-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 4px;
	}
	.ao-carousel-item {
		border-radius: 4px;
		width: 100%;
		height: 100%;
	}
	.ao-carousel-item-image {
		border-radius: 4px;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.ao-carousel-main {
		background: rgb(var(--v-theme-secondary));
		border-radius: 4px;
		margin-bottom: 8px;
	}
	.ao-carousel-preview {
		margin-left: 4px;
		margin-right: 4px;
		background: rgb(var(--v-theme-secondary));
		border-radius: 4px;
		&.carousel__slide--active {
			border: 2px solid #4a86c7;
		}
	}
	.collapse-icon-background {
		background: #d9e4ec;
		border-radius: 50%;
		width: 16px;
		height: 16px;
		color: rgb(var(--v-theme-primary));
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.ao-carousel-next-item-icon {
		cursor: pointer;
		height: 10px !important;
		transition: transform 0.3s ease-out;
		display: flex;
	}
	.ao-carousel-prev-item-icon {
		cursor: pointer;
		height: 10px !important;
		transition: transform 0.3s ease-out;
		transform: rotate(180deg);
		display: flex;
	}
}
.ao-carousel-full-size-btn {
	position: absolute;
	z-index: 10;
	right: 8px;
	top: 8px;
}
.ao-carousel-full-screen {
	width: 100vw;
	height: 100vh;
	margin-left: -24px;
	margin-top: -24px;
}
</style>
